// Existing mock data and functions
export const testimonials = [
  {
    id: 1,
    name: "Emma van den Berg",
    location: "Amsterdam",
    rating: 5,
    text: "Basic Job completely transformed our bathroom! The team was professional, clean, and finished on time. Highly recommend!",
    service: "Bathroom Renovation"
  },
  {
    id: 2,
    name: "Lucas Jansen",
    location: "Amsterdam",
    rating: 5,
    text: "We hired Basic Job for a complete house renovation. The attention to detail and quality of work exceeded our expectations. Great value!",
    service: "House Renovation"
  },
  {
    id: 3,
    name: "Sophie Bakker",
    location: "Amsterdam",
    rating: 5,
    text: "Fast, reliable, and affordable plumbing service. They fixed our issue quickly and explained everything clearly. Will definitely use again!",
    service: "Plumbing"
  },
  {
    id: 4,
    name: "Daan Vermeer",
    location: "Amsterdam",
    rating: 5,
    text: "The painting job on our apartment was flawless. Clean work, professional team, and the color consultation was really helpful!",
    service: "Painting"
  }
];

export const services = [
  {
    id: 1,
    title: "House Renovation",
    description: "Complete home transformations from concept to completion. We handle everything to create your dream space.",
    icon: "Home",
    image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3NzYyMDMwNDR8MA&ixlib=rb-4.1.0&q=85",
    features: ["Full home renovations", "Kitchen remodeling", "Living space upgrades", "Custom design solutions"]
  },
  {
    id: 2,
    title: "Bathroom Renovation",
    description: "Transform your bathroom into a modern sanctuary with our expert renovation services.",
    icon: "Bath",
    image: "https://images.unsplash.com/photo-1620626011761-996317b8d101?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxiYXRocm9vbSUyMHJlbm92YXRpb258ZW58MHx8fHwxNzc2MjAyOTkyfDA&ixlib=rb-4.1.0&q=85",
    features: ["Modern fixtures", "Tile installation", "Waterproofing", "Complete redesign"]
  },
  {
    id: 3,
    title: "Painting",
    description: "Professional interior and exterior painting services that bring fresh life to your property.",
    icon: "Paintbrush",
    image: "https://images.unsplash.com/photo-1717281234297-3def5ae3eee1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxob3VzZSUyMHBhaW50aW5nfGVufDB8fHx8MTc3NjIwMzAwMHww&ixlib=rb-4.1.0&q=85",
    features: ["Interior painting", "Exterior painting", "Color consultation", "Premium finishes"]
  },
  {
    id: 4,
    title: "Plumbing",
    description: "Expert plumbing services for installations, repairs, and maintenance. Fast and reliable.",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1676210133055-eab6ef033ce3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxwbHVtYmluZ3xlbnwwfHx8fDE3NzYyMDMwMDR8MA&ixlib=rb-4.1.0&q=85",
    features: ["Emergency repairs", "Pipe installation", "Leak detection", "Fixture replacement"]
  },
  {
    id: 5,
    title: "Plastering",
    description: "High-quality plastering for smooth, perfect walls and ceilings. Professional finish guaranteed.",
    icon: "Square",
    image: "https://images.unsplash.com/photo-1629195354259-fe4ff202c8e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxtYW4lMjBwbGFzdGVyaW5nJTIwd2FsbCUyMHRyb3dlbHxlbnwwfHx8fDE3NzYzNzQxNDF8MA&ixlib=rb-4.1.0&q=85",
    features: ["Wall plastering", "Ceiling work", "Repair work", "Smooth finishes"]
  }
];

export const projects = [
  {
    id: 1,
    title: "Toilet Renovation",
    category: "Bathroom",
    image: "https://customer-assets.emergentagent.com/job_craft-house/artifacts/x22a5i77_IMG_20210821_190801_083.webp"
  },
  {
    id: 2,
    title: "Bright Kitchen Upgrade",
    category: "Kitchen",
    image: "https://customer-assets.emergentagent.com/job_craft-house/artifacts/aduf4tsy_IMG_20200604_220251_930.jpg"
  },
  {
    id: 3,
    title: "Contemporary Living Space",
    category: "Living Room",
    image: "https://customer-assets.emergentagent.com/job_craft-house/artifacts/2ap4s2f0_IMG_20220825_213837_255.jpg"
  },
  {
    id: 5,
    title: "Modern Interior Design",
    category: "Interior",
    image: "https://customer-assets.emergentagent.com/job_craft-house/artifacts/34n4kf92_IMG-20200604-WA0000.jpg"
  },
  {
    id: 6,
    title: "Modern Bathroom Renovation",
    category: "Bathroom",
    image: "https://customer-assets.emergentagent.com/job_craft-house/artifacts/4foimx74_IMG_20220423_011958_953.jpg"
  },
  {
    id: 7,
    title: "Glossy Floor Tiles & LED Ceiling",
    category: "Living Room",
    image: "https://customer-assets.emergentagent.com/job_craft-house/artifacts/1d1zsj51_IMG-20180910-WA0025.jpeg"
  }
];

// Mock form submission
export const submitQuoteRequest = async (formData) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  return {
    success: true,
    message: "Thank you! We'll contact you within 24 hours."
  };
};

export const submitContactForm = async (formData) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  return {
    success: true,
    message: "Message sent successfully!"
  };
};

// NEW: Appointment mock data and functions
let mockAppointments = [
  {
    id: "apt-001",
    customerName: "Jan de Vries",
    email: "jan@example.com",
    phone: "+31 6 1234 5678",
    service: "Bathroom Renovation",
    date: "2024-12-20",
    time: "10:00",
    address: "Prinsengracht 123, Amsterdam",
    notes: "Need quote for complete bathroom renovation",
    status: "confirmed",
    createdAt: new Date().toISOString()
  },
  {
    id: "apt-002",
    customerName: "Maria Jensen",
    email: "maria@example.com",
    phone: "+31 6 9876 5432",
    service: "Painting",
    date: "2024-12-21",
    time: "14:00",
    address: "Jordaan 456, Amsterdam",
    notes: "Living room and bedroom painting",
    status: "confirmed",
    createdAt: new Date().toISOString()
  }
];

// Business hours configuration
export const businessHours = {
  monday: { open: "09:00", close: "17:00", enabled: true },
  tuesday: { open: "09:00", close: "17:00", enabled: true },
  wednesday: { open: "09:00", close: "17:00", enabled: true },
  thursday: { open: "09:00", close: "17:00", enabled: true },
  friday: { open: "09:00", close: "17:00", enabled: true },
  saturday: { open: "10:00", close: "14:00", enabled: true },
  sunday: { open: "10:00", close: "14:00", enabled: false }
};

// Generate time slots for a given day
export const generateTimeSlots = (date) => {
  const dayName = date.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
  const hours = businessHours[dayName];
  
  if (!hours.enabled) return [];
  
  const slots = [];
  const [openHour, openMin] = hours.open.split(':').map(Number);
  const [closeHour, closeMin] = hours.close.split(':').map(Number);
  
  for (let hour = openHour; hour < closeHour; hour++) {
    slots.push(`${String(hour).padStart(2, '0')}:00`);
    if (hour + 1 < closeHour || (hour + 1 === closeHour && closeMin > 0)) {
      slots.push(`${String(hour).padStart(2, '0')}:30`);
    }
  }
  
  return slots;
};

// Check if time slot is available
export const isSlotAvailable = (date, time) => {
  const dateStr = date.toISOString().split('T')[0];
  return !mockAppointments.some(
    apt => apt.date === dateStr && apt.time === time && apt.status !== 'cancelled'
  );
};

// Get available slots for a date
export const getAvailableSlots = async (date) => {
  await new Promise(resolve => setTimeout(resolve, 300));
  
  const allSlots = generateTimeSlots(date);
  return allSlots.filter(time => isSlotAvailable(date, time));
};

// Book appointment
export const bookAppointment = async (appointmentData) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  const newAppointment = {
    id: `apt-${Date.now()}`,
    ...appointmentData,
    status: "confirmed",
    createdAt: new Date().toISOString()
  };
  
  mockAppointments.push(newAppointment);
  
  return {
    success: true,
    appointment: newAppointment,
    message: "Appointment booked successfully! You'll receive a confirmation email shortly."
  };
};

// Get appointment by ID
export const getAppointment = async (appointmentId) => {
  await new Promise(resolve => setTimeout(resolve, 300));
  
  const appointment = mockAppointments.find(apt => apt.id === appointmentId);
  if (!appointment) {
    return { success: false, message: "Appointment not found" };
  }
  
  return { success: true, appointment };
};

// Reschedule appointment
export const rescheduleAppointment = async (appointmentId, newDate, newTime) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  const appointment = mockAppointments.find(apt => apt.id === appointmentId);
  if (!appointment) {
    return { success: false, message: "Appointment not found" };
  }
  
  appointment.date = newDate;
  appointment.time = newTime;
  appointment.updatedAt = new Date().toISOString();
  
  return {
    success: true,
    appointment,
    message: "Appointment rescheduled successfully!"
  };
};

// Cancel appointment
export const cancelAppointment = async (appointmentId) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  const appointment = mockAppointments.find(apt => apt.id === appointmentId);
  if (!appointment) {
    return { success: false, message: "Appointment not found" };
  }
  
  appointment.status = "cancelled";
  appointment.cancelledAt = new Date().toISOString();
  
  return {
    success: true,
    message: "Appointment cancelled successfully"
  };
};
